import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";
import {GelContentContainer, GelContentRow, RegularCard} from 'cw-styleguide-react';
import Tabs from "../../../components/Tabs";
import AutocompleteSearch from "../../../components/AutocompleteSearch";
import Helmet from 'react-helmet';

class IndustriesLandingView extends Component {
  render() {
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.t('industry_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <AutocompleteSearch  jobs={this.props.jobs}/>
        <GelContentContainer>
          <Tabs/>
          <h2>{this.props.t('industry_title')}</h2>
          <p>{ this.props.t('view.industries.introduction')}</p>
          <GelContentRow>
            {this.props.industries.map((industry, index) => {
              return (
                <RegularCard key={index} width={33} link={{
                  to: route("industries") + route('industry', {industry: industry.slug})
                }} alt={industry.landingPageImage.alt} source={industry.landingPageImage.src} title={industry.name}/>
              );
            })}
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(IndustriesLandingView);
